var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import loadable from '@loadable/component';
import { usePreliminarySession } from './use-preliminary-session';
var PreliminaryOrder = loadable(function () { return import(/* webpackChunkName: "browsing-overlays" */ './preliminary-order'); }, {
    resolveComponent: function (mod) { return mod.PreliminaryOrder; },
});
export var LazyPreliminaryOrder = function (_a) {
    var icon = _a.icon, props = __rest(_a, ["icon"]);
    var _b = usePreliminarySession(props), preliminarySession = _b.preliminarySession, cancelPreliminarySession = _b.cancelPreliminarySession;
    if (preliminarySession.id) {
        return (React.createElement(PreliminaryOrder, { icon: icon, preliminarySession: preliminarySession, cancelPreliminarySession: cancelPreliminarySession }));
    }
    return null;
};
